function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.7395 7.9927L14 7.9927V9.9927L20.987 9.99271L20.9869 3H18.9869L18.987 6.32704C18.2756 5.45086 17.3996 4.70867 16.3976 4.14756C14.4217 3.04097 12.1012 2.72 9.89902 3.24869C7.69688 3.77738 5.77501 5.11685 4.5168 6.99989C3.25859 8.88293 2.75655 11.1711 3.11083 13.4079C3.46511 15.6448 4.64967 17.6658 6.42818 19.0679C8.2067 20.4699 10.4484 21.15 12.7062 20.9723C14.9639 20.7946 17.0716 19.7723 18.6089 18.1092C19.686 16.9441 20.4275 15.5245 20.775 14H18.7105C17.8503 16.8921 15.1714 19.0012 12 19.0012C8.13401 19.0012 5 15.8672 5 12.0012C4.99999 11.9641 5.00029 11.9271 5.00087 11.8902C5.02324 10.4508 5.48005 9.11687 6.24594 8.01373C6.7963 7.21927 7.50055 6.5539 8.30919 6.0521C9.06039 5.58506 9.90655 5.25635 10.8121 5.10155C11.6026 4.96539 12.4059 4.96695 13.1874 5.10146C14.0804 5.25404 14.9156 5.57574 15.659 6.03244C16.4853 6.53906 17.1918 7.20826 17.7395 7.9927Z",
  fill: "#220C4A"
});

var SvgRetryIcon = function SvgRetryIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRetryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/retry-icon.4a9df43b.svg";
export { ForwardRef as ReactComponent };